// import './App.css';
// import Login from "./Components/Login"
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Dashboard from './Components/Dashboard';
// import ProtectedRoute from './Components/ProtectedRoute';
// import UploadComponent from './Components/UploadComponent';
// import UploadStock from './Components/UploadStock';
// import ProcurementList from './Components/ProcurementList';
// import StockList from './Components/StockList';
// function App() {
//   return (
//     <div className="App">
//       <Router>
// <Routes>
//   <Route path='/' element={<Login/>}></Route>
//   {/* <Route path="/dashboard" element={<Dashboard/>}></Route> */}
//   <Route
//             path="/dashboard"
//             element={
//               <ProtectedRoute>
//                 <Dashboard />
//               </ProtectedRoute>
//             }
//           />
//   <Route
//   path='/uploadProcurement'
//   element={
//     <ProtectedRoute>
//       <UploadComponent/>
//     </ProtectedRoute>
//   }
//   />
//   <Route
//   path='/uploadStock'
//   element={
//     <ProtectedRoute>
//       <UploadStock/>
//     </ProtectedRoute>
//   }/>
// <Route
//   path='/procurementList'
//   element={
//     <ProtectedRoute>
//       <ProcurementList/>
//     </ProtectedRoute>
//   }/>
//   <Route
//   path='/stockList'
//   element={
//     <ProtectedRoute>
//       <StockList/>
//     </ProtectedRoute>
//   }/>
  
// </Routes>
//       </Router>
//     </div>
//   );
// }

// export default App;
// import './App.css';
// import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
// import Login from "./Components/Login";
// import Dashboard from './Components/Dashboard';
// import ProtectedRoute from './Components/ProtectedRoute';
// import UploadComponent from './Components/UploadComponent';
// import UploadStock from './Components/UploadStock';
// import ProcurementList from './Components/ProcurementList';
// import StockList from './Components/StockList';
// import Layout from './Components/Layout'; // Import the layout
// import axios from 'axios'; // Import axios


// axios.interceptors.response.use(
//   response => response,
//   error => {
//     if (error.response?.status === 401) {
//       localStorage.removeItem('user');
//       localStorage.setItem('sessionExpired', 'true');
//       window.location.href = '/'; // Redirect to login
//     }
//     return Promise.reject(error);
//   }
// );


// function App() {
//   return (
//     <div className="App">
//       <Router>
//         <Routes>
//           <Route path='/' element={<Login />} />

//           <Route
//             path="/dashboard"
//             element={
//               <ProtectedRoute>
                
//                   <Dashboard />
                
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/uploadProcurement"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <UploadComponent />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/uploadStock"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <UploadStock />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/procurementList"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <ProcurementList />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/stockList"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <StockList />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />
//         </Routes>
//       </Router>
//     </div>
//   );
// }

// export default App;
// import './App.css';
// import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
// import Login from "./Components/Login";
// import Dashboard from './Components/Dashboard';
// import ProtectedRoute from './Components/ProtectedRoute';
// import UploadComponent from './Components/UploadComponent';
// import UploadStock from './Components/UploadStock';
// import ProcurementList from './Components/ProcurementList';
// import StockList from './Components/StockList';
// import ApprovedTransactions from './Components/ApprovedTransactions';
// import Transactions from './Components/Transactions';
// import PendingStock from './Components/PendingStock';
// import ApprovedStock from './Components/ApprovedStock';
// import Layout from './Components/Layout';
// import axios from 'axios';


// // Global 401 handler
// axios.interceptors.response.use(
//   response => response,
//   error => {
//     if (error.response?.status === 401) {
//       localStorage.removeItem('user');
//       localStorage.setItem('sessionExpired', 'true');
//       window.location.href = '/';
//     }
//     return Promise.reject(error);
//   }
// );

// function App() {
//   return (
//     <div className="App">
//       <Router>
//         <Routes>
//           <Route path="/" element={<Login />} />

//           <Route
//             path="/dashboard"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   {/* ✅ Role check inside element function */}
//                   {(() => {
//                     const user = JSON.parse(localStorage.getItem('user') || '{}');
//                     const role = user?.role;
//                     return role === 'admin' ? <Dashboard /> : <Navigate to="/transactions" />;
//                   })()}
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/uploadProcurement"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <UploadComponent />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/uploadStock"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <UploadStock />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/procurementList"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <ProcurementList />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/stockList"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <StockList />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/transactions"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <Transactions />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />

//           <Route
//             path="/approvedtransaction"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <ApprovedTransactions />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/pendingstock"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <PendingStock />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />
//           <Route
//             path="/approvedstock"
//             element={
//               <ProtectedRoute>
//                 <Layout>
//                   <ApprovedStock />
//                 </Layout>
//               </ProtectedRoute>
//             }
//           />
//         </Routes>
//       </Router>
//     </div>
//   );
// }

// export default App;
import './App.css';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from "./Components/Login";
import Dashboard from './Components/Dashboard';
import ProtectedRoute from './Components/ProtectedRoute';
import UploadComponent from './Components/UploadComponent';
import UploadStock from './Components/UploadStock';
import ProcurementList from './Components/ProcurementList';
import StockList from './Components/StockList';
import ApprovedTransactions from './Components/ApprovedTransactions';
import Transactions from './Components/Transactions';
import PendingStock from './Components/PendingStock';
import ApprovedStock from './Components/ApprovedStock';
import Layout from './Components/Layout';
import DashboardRoute from './Components/DashboardRoute'; // ✅ NEW IMPORT
import axios from 'axios';

// ✅ Global 401 handler
axios.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('user');
      localStorage.setItem('sessionExpired', 'true');
      window.location.href = '/';
    }
    return Promise.reject(error);
  }
);

function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          {/* Public Route */}
          <Route path="/" element={<Login />} />

          {/* Admin Dashboard */}
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <Layout>
                  <DashboardRoute /> {/* ✅ Route role handling logic moved here */}
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Other protected routes */}
          <Route
            path="/uploadProcurement"
            element={
              <ProtectedRoute>
                <Layout>
                  <UploadComponent />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/uploadStock"
            element={
              <ProtectedRoute>
                <Layout>
                  <UploadStock />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/procurementList"
            element={
              <ProtectedRoute>
                <Layout>
                  <ProcurementList />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/stockList"
            element={
              <ProtectedRoute>
                <Layout>
                  <StockList />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/transactions"
            element={
              <ProtectedRoute>
                <Layout>
                  <Transactions />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/approvedtransaction"
            element={
              <ProtectedRoute>
                <Layout>
                  <ApprovedTransactions />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/pendingstock"
            element={
              <ProtectedRoute>
                <Layout>
                  <PendingStock />
                </Layout>
              </ProtectedRoute>
            }
          />

          <Route
            path="/approvedstock"
            element={
              <ProtectedRoute>
                <Layout>
                  <ApprovedStock />
                </Layout>
              </ProtectedRoute>
            }
          />

          {/* Optional fallback for invalid routes */}
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
